/**
 * @fileoverview Shared JWT session payload schema used when signing tokens on
 * the backend and decoding claims on the frontend. Verification stays
 * server-side only.
 */

import { z } from 'zod';

export const JwtPayloadSchema = z.object({
  sub: z.string().min(1),
  email: z.string().optional(),
  name: z.string().optional(),
  picture: z.string().optional(),
  github_login: z.string().optional(),
});

export type JwtPayload = z.infer<typeof JwtPayloadSchema>;
